export const SIDE_NAV_WIDE_SETTING = 'WEB_SIDE_NAV_WIDE';
